import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import ALERT_MAP from "../../maps/alertMap";
import Switch from "@mui/material/Switch";
import Select from "@mui/material/Select";
import MenuItem from '@mui/material/MenuItem';
import {colors} from "../../maps/colors";
import Button from "@mui/material/Button";
import {api} from "../../maps/data";
import TextField from "@mui/material/TextField";

const WrapperStyled = styled.div`
    width: 400px;
    margin-top: 67px;
    padding: 10px;
`;

const ItemStyled = styled.div`
    margin: 15px 0;
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    border-color: rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23);
    padding: 10px;
`;

const ItemTitleStyled = styled.div`
    margin-bottom: 10px;
`;

const ItemEditStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    align-items: center;
`;

const TitleStyled = styled.div`
    font-weight: 600;
    line-height: 1.57143;
    font-family: "Public Sans", sans-serif;
    text-align: center;
    font-size: 22px;
    text-transform: capitalize;
`;

const SettingsFromStyled = styled.div`
    font-weight: 400;
    line-height: 1.57143;
    font-family: "Public Sans", sans-serif;
    text-align: center;
    font-size: 17px;
`;

const InputWrapperStyled = styled.div`

`;

const ButtonsWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 80px 160px;
    grid-gap: 10px;
`;

const AlertSettingsEdit = ({data, type, onClose, site, field}) => {
    const [enabled, s_enabled] = useState([]);
    const [severity, s_severity] = useState([]);
    const [compReady, s_compReady] = useState(false);
    const [thresholds, s_thresholds] = useState([]);

    const alertTypesList = Object.keys(ALERT_MAP.severity);

    let alertSettings = data?.alertSettings;
    let settingsFrom = null;
    const siteSettings = site?.alertSettings;
    const fieldSettings = field?.alertSettings;
    if (!alertSettings && siteSettings) {
        settingsFrom = "Site";
        alertSettings = siteSettings;
    }
    if (!alertSettings && fieldSettings) {
        settingsFrom = "Field";
        alertSettings = fieldSettings;
    }

    useEffect(() => {
        if (data) {
            const enabledList = [];
            const sevList = [];
            const thresholdList = [];

            ALERT_MAP.values.forEach(ll => {
                let isEnabled = true;
                let sev = "CRITICAL";
                let threshold = ll.input?.threshold || 0;

                if (alertSettings?.[ll.code] !== undefined) {
                    isEnabled = alertSettings[ll.code].isEnabled;
                    sev = alertSettings[ll.code].sev;

                    if (alertSettings[ll.code].threshold) {
                        threshold = alertSettings[ll.code].threshold;
                    }
                }

                sevList.push(sev);
                enabledList.push(isEnabled);
                thresholdList.push(threshold);
            });
            s_enabled(enabledList);
            s_severity(sevList);
            s_thresholds(thresholdList);
            s_compReady(true);
        }
    }, [data?.alertSettings]);

    const enableDisableHandle = (e, isEnabled, idx) => {
        const newList = [...enabled];
        newList[idx] = isEnabled;
        s_enabled(newList);
    };

    const sevHandle = (e, data, idx) => {
        const newList = [...severity];
        newList[idx] = data;
        s_severity(newList);
    };

    const thresholdHandle = (e, data, idx) => {
        const newList = [...thresholds];
        newList[idx] = data;
        s_thresholds(newList);
    };

    const saveSettings = async () => {
        const objToSave = {};
        ALERT_MAP.values.forEach((ll, idx) => {
            objToSave[ll.code] = {
                isEnabled: enabled[idx],
                sev: severity[idx]
            };

            if (thresholds[idx] && ll.input) {
                objToSave[ll.code].threshold = Number(thresholds[idx]);
            }
        });
        switch (type) {
            case 'site':
                await api({
                    type: "setAlarmsSite",
                    data: {
                        siteId: data._id,
                        alertSettings: objToSave
                    }
                });
                break;
            case 'field':
                await api({
                    type: "setAlarmsField",
                    data: {
                        fieldId: data._id,
                        alertSettings: objToSave
                    }
                });
                break;
            case 'sensor':
                await api({
                    type: "setAlarmsField",
                    data: {
                        sensorId: data.sensorId,
                        alertSettings: objToSave
                    }
                });
                break;
        }

        onClose();
    };

    const resetSettings = async () => {
        switch (type) {
            case 'site':
                await api({
                    type: "setAlarmsSite",
                    data: {
                        siteId: data._id,
                        alertSettings: null
                    }
                });
                break;
            case 'field':
                await api({
                    type: "setAlarmsField",
                    data: {
                        fieldId: data._id,
                        alertSettings: null
                    }
                });
                break;
            case 'sensor':
                await api({
                    type: "setAlarmsField",
                    data: {
                        sensorId: data.sensorId,
                        alertSettings: null
                    }
                });
                break;
        }

        onClose();
    };

    return (
        <WrapperStyled>
            <TitleStyled>{`${type} alerts`}</TitleStyled>
            {settingsFrom && (
                <SettingsFromStyled>Settings from: {settingsFrom}</SettingsFromStyled>
            )}
            {compReady && ALERT_MAP.values.map((pp, idx) => {

                let show = true;
                if (pp.limitedTo) {
                    const isInList = pp.limitedTo.indexOf(type);
                    if (isInList === -1) {
                        show = false;
                    }
                }

                if (!show) {
                    return null;
                }

                return (
                    <ItemStyled key={pp.name}>
                        <ItemTitleStyled>
                            {pp.name}
                        </ItemTitleStyled>
                        <ItemEditStyled>
                            <Switch
                                checked={enabled[idx]}
                                onChange={(e, k) => enableDisableHandle(e, k, idx)}
                            />
                            <Select
                                labelId="Severity"
                                label="Severity"
                                value={severity[idx]}
                                onChange={(e, data) => {
                                    sevHandle(e, data?.props?.value, idx);
                                }}
                            >
                                {alertTypesList.map((dd, idxx) => {
                                    let color = colors.RED1;
                                    if (dd === 'WARNING') {
                                        color = colors.LIGHT_ORANGE;
                                    }
                                    if (dd === 'INFO') {
                                        color = colors.SUCCESS_GREEN;
                                    }

                                    return (
                                        <MenuItem
                                            sx={{
                                                color
                                            }}
                                            key={dd}
                                            className={dd}
                                            value={dd}
                                        >
                                            {ALERT_MAP.severity[dd]}
                                        </MenuItem>
                                    );
                                })}
                            </Select>

                            <div></div>
                            {pp.input && (
                                <InputWrapperStyled>
                                    <TextField
                                        type="number"
                                        label={pp.input.label}
                                        variant="outlined"
                                        size="small"
                                        value={thresholds[idx]}
                                        onChange={e => {
                                            thresholdHandle(e, e.target.value, idx);
                                        }}
                                    />
                                </InputWrapperStyled>
                            )}
                        </ItemEditStyled>
                    </ItemStyled>
                );
            })}
            <ButtonsWrapperStyled>
                <Button onClick={saveSettings} variant="contained">Save</Button>
                <Button onClick={resetSettings} color="error" variant="contained">Reset Settings</Button>
            </ButtonsWrapperStyled>
        </WrapperStyled>
    );
};

export default AlertSettingsEdit;